import axios from 'axios';
import router from './router'
import { message, Modal } from 'ant-design-vue';
import store from '@/store';
import i18n from './lang';
console.log(process.env)

// ============================================================
// 兑换中心专用 axios — 完全独立，不走主站任何逻辑
// ============================================================
const duihuanAxios = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    }
});

// 请求拦截：仅使用兑换中心专用 JWT，走独立 header 字段，不与主站 Authorization 冲突
duihuanAxios.interceptors.request.use(config => {
    const token = localStorage.getItem('duihuan_token');
    if (token) {
        config.headers['X-Duihuan-Token'] = token;
    }
    return config;
});

// 响应拦截：把非 10000 的业务错误统一弹 message，不走主站的 modal / captcha / 实名等逻辑
duihuanAxios.interceptors.response.use(
    response => {
        const data = response?.data || {};
        if (data.status !== undefined && data.status !== 10000 && data.msg) {
            message.error(data.msg);
        }
        return response;
    },
    error => {
        const status = error?.response?.status;
        const msg = error?.response?.data?.msg;
        if (msg) {
            message.error(msg);
        } else if (status >= 500) {
            message.error('服务异常，请稍后再试');
        } else if (status === 401 || status === 403) {
            message.error('登录状态已失效，请重新登录');
        }
        return Promise.reject(error);
    }
);

// ============================================================
// 主站 axios — 保留原有全部逻辑
// ============================================================
const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    }
});

axiosInstance.defaults.withCredentials = true;

const noAuthRoutes = ['/login/', '/register/', '/home/', 'userauth/login/', 'api/userauth/login/', 'userauth/get_sms_code/', 'api/userauth/get_sms_code/'];

// 请求拦截器
axiosInstance.interceptors.request.use(
    config => {
        const token = localStorage.getItem('access_token');
        if (token && !noAuthRoutes.includes(config.url)) {
            config.headers['Authorization'] = `${token}`;
        }
        const captchaUuid = localStorage.getItem('captchaUuid')
        config.headers['x-captcha-uuid'] = `${captchaUuid}`;
        config.headers['language'] = i18n.global.locale || '';
        config.headers['HTTP_ACCEPT_LANGUAGE'] = i18n.global.locale || '';
        config.headers['Accept-Language'] = i18n.global.locale || '';

        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
axiosInstance.interceptors.response.use(
    response => {
        const captchaUuid = response.headers['x-captcha-uuid']
        if (captchaUuid) {
            localStorage.setItem('captchaUuid', captchaUuid);
        }

        // 如果包含authorization
        const newToken = response.headers['Authorization'];
        if (newToken && newToken.split(".").length === 3) {
            localStorage.setItem('access_token', newToken);
        }
        const alterType = response?.data?.alter_type;
        // 处理非正常业务状态吗，相应提示
        if (response.data.status != 10000 && response.data.msg) {
            if (alterType === 'message') {
                message.error(response.data.msg);
            } else {
                const payload = {
                    tmp: Date.now(),
                    alterType: "modal",
                    msg: response.data.msg || "接口请求错误",
                    level: response.data.level || "info",
                    title: response.data.title || "提示",
                  };
                console.log(payload)
                store.dispatch("gobalMessageModal/showModal", payload);
            }
        }
        if (response.data.status == 10000 && response.data.msg) {
            if (alterType === 'message') {
                message.success(response.data.msg);
            } else {
                const payload = {
                    tmp: Date.now(),
                    alterType: "modal",
                    msg: response.data.msg || "接口请求错误",
                    level: response.data.level || "info",
                    title: response.data.title || "提示",
                  };
                console.log(payload)
                store.dispatch("gobalMessageModal/showModal", payload);
            }
        }
        // 身份验证
        if (response.data.status == 10002) {
            store.dispatch("realnameVerificationModal/openRealModal");
        }
        return response;
    },
    error => {
        console.log(error.response);
        if (error.response && (error.response.status === 401 || error.response?.data?.status === 10401)) {
            localStorage.removeItem('access_token');
            store.commit('SET_USER', null);
            store.commit('SET_AUTHENTICATED', false);
            if (router.currentRoute.value.meta.cdkPopupAuth) {
                store.commit("SET_LOGINMODALTYPE", "login");
                store.dispatch("authModal/showLoginModal");
            } else {
                router.push("/login/?redirect=" + router.currentRoute.value.fullPath);
            }
        } else if (error.response?.status === 404) {
            message.error('页面路径不存在');
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;
export { duihuanAxios };
